import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTriggerIziviaMonprojetWorkOrders } from './hooks/useTriggerIziviaMonprojetWorkOrders';

export interface TriggerIziviaMonprojetWorkOrdersButtonProps {
  organizationId: string;
}

export function TriggerIziviaMonprojetWorkOrdersButton({
  organizationId,
}: TriggerIziviaMonprojetWorkOrdersButtonProps) {
  const { t } = useTranslation('organization');
  const { canTrigger, isPending, onTrigger } =
    useTriggerIziviaMonprojetWorkOrders(organizationId);

  if (!canTrigger) {
    return null;
  }

  return (
    <Tooltip title={t('detail.triggerIziviaMonprojetWorkOrdersHint')}>
      <Button
        size="small"
        loading={isPending}
        disabled={isPending}
        onClick={onTrigger}
      >
        {t('detail.triggerIziviaMonprojetWorkOrders')}
      </Button>
    </Tooltip>
  );
}
